import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DataGridFlexSales, useDataGridFlexSales } from '../DataGridFlexSales';
import handlerFactory, { MastersStatusDataGridContext } from './handlerFactory';
import { FiscalDetail } from '../../types';
import { reportFiscalDetailSelector } from '../../state';

const DataGridConfig = () => {
  const { handler } = useDataGridFlexSales<FiscalDetail, MastersStatusDataGridContext>();

  const { t } = useTranslation();
  const title = t('fiscal-detail.title');

  const mastersImportResource = useSelector(reportFiscalDetailSelector);

  const { loading, data } = mastersImportResource;

  const gridContext = useMemo(
    () => ({
      t,
    }),
    [t]
  );

  handler.setData(data);
  handler.setContext(gridContext);
  handler.setTitle(title);
  handler.setLoading(loading);

  return null;
};

const FiscalDetailDataGrid = () => (
  <DataGridFlexSales handlerFactory={handlerFactory}>
    <DataGridConfig />
  </DataGridFlexSales>
);

export default FiscalDetailDataGrid;
